import styled from 'styled-components';
import {
  Flex,
  isUserWithRoles,
  SelectInput,
  TableSelectCss,
  useCombinedUser,
  UserRoles,
} from '@equifinance/shared';
import { useUnderwritersContext } from '../../../contexts/underwriters';
import { Application, useApplicationsContext } from '../../../contexts/applications';

const UnderwriterColumnContainer = styled(Flex)`
  width: 100%;
  max-width: 100%;
`;

export default function UnderwriterColumn({ row }: { row: Application }) {
  const { user } = useCombinedUser();
  const { updateUnderwriterOwner } = useApplicationsContext();
  const { underwriters } = useUnderwritersContext();
  const disabled = !isUserWithRoles([UserRoles.UNDERWRITER], user);

  const options = underwriters
    .filter((underwriter) => underwriter.isActive)
    .reduce((prev, current) => ({
      ...prev,
      [current.id]: current.displayName,
    }), {});

  const onChangeUnderwriter = async (underwriterId: string) => {
    const underwriter = underwriters.find((assign) => assign.id === underwriterId);
    if (!underwriter || row.underwriterAssignedToId === underwriterId) return;
    await updateUnderwriterOwner(row.id, underwriter.id, underwriter.displayName);
  };

  return (
    <UnderwriterColumnContainer>
      <SelectInput
        id={`select-Underwriter-${row.id}`}
        value={row.underwriterAssignedToId}
        options={options}
        onChange={(value: string) => onChangeUnderwriter(value)}
        dropdownCss={TableSelectCss}
        disabled={disabled}
        showValueTooltip="onTruncateHover"
        isTooltipError
        small
      />
    </UnderwriterColumnContainer>
  );
}
